"use strict";
var appn;
(function (appn) {
    var tour;
    (function (tour) {
        let _scrollHandler = null;
        let _resizeHandler = null;
        let _$singleTarget = null;
        let _$mergedTargets = null;
        function show(options) {
            hide();
            if (options.targets && options.targets.length > 0) {
                _$mergedTargets = options.targets;
                _$singleTarget = options.target.first();
            }
            else
                _$singleTarget = options.target.first();
            if (_$singleTarget.length === 0)
                return;
            let $spotlight = $('#tour-spotlight');
            if ($spotlight.length === 0)
                $spotlight = $('<div id="tour-spotlight"></div>').appendTo('body');
            const showTourAfterDelay = () => {
                if (!_$singleTarget || _$singleTarget.length === 0)
                    return;
                if (_$mergedTargets && _$mergedTargets.length > 0) {
                    positionSpotlightForMultiple($spotlight, _$mergedTargets);
                    setupPositionListenersForMultiple($spotlight, _$mergedTargets);
                }
                else {
                    positionSpotlight($spotlight, _$singleTarget);
                    setupPositionListeners($spotlight, _$singleTarget);
                }
                const backBtn = options.showBack !== false ? `<button class="btn btn-sm btn-secondary tour-back mr-1">${T("Back")}</button>` : '';
                const content = `
            <div class="tour-content">
                <p>${options.message}</p>
                <div class="d-flex align-items-center justify-content-between mt-3">
                    <small class="text-muted">${T("Step {0} of {1}", options.step, options.totalSteps)}</small>
                    <div class="tour-buttons">
                        ${backBtn}
                        <button class="btn btn-sm btn-success tour-next">${T("Next")}</button>
                    </div>
                </div>
            </div>`;
                _$singleTarget.popover('dispose');
                _$singleTarget.popover({
                    title: `<strong>${options.title}</strong>`,
                    content: content,
                    html: true,
                    sanitize: false,
                    placement: options.placement || 'right',
                    container: 'body',
                    boundary: 'viewport',
                    offset: '0, 10',
                    trigger: 'manual',
                    template: '<div class="popover tour-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
                }).popover('show');
                if (options.scrollIntoView !== false && _$singleTarget.length > 0)
                    _$singleTarget[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                const $nextBtn = $('.tour-popover .tour-next');
                const $backBtn = $('.tour-popover .tour-back');
                $nextBtn.off('.appnTour').on('click.appnTour', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    options.onNext();
                });
                if ($backBtn.length > 0 && options.showBack !== false) {
                    $backBtn.off('.appnTour').on('click.appnTour', (e) => {
                        var _a;
                        e.preventDefault();
                        e.stopPropagation();
                        (_a = options.onBack) === null || _a === void 0 ? void 0 : _a.call(options);
                    });
                }
            };
            const delay = options.delayBeforeShow !== undefined ? options.delayBeforeShow : 0;
            setTimeout(showTourAfterDelay, delay);
        }
        tour.show = show;
        function hide() {
            const $popovers = $('.tour-popover');
            const $spotlight = $('#tour-spotlight');
            $popovers.each(function () {
                $(this).popover('dispose');
            });
            if ($spotlight.length > 0)
                $spotlight.css({ width: 0, height: 0, opacity: 0 });
            removePositionListeners();
            _$singleTarget = null;
            _$mergedTargets = null;
        }
        tour.hide = hide;
        function positionSpotlight($spotlight, $target) {
            if ($target.length === 0)
                return;
            const rect = $target[0].getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            $spotlight.css({
                position: 'absolute',
                top: rect.top + scrollTop,
                left: rect.left + scrollLeft,
                width: rect.width,
                height: rect.height,
                opacity: 1,
                transition: 'all 0.3s ease'
            });
        }
        function positionSpotlightForMultiple($spotlight, $targets) {
            if ($targets.length === 0)
                return;
            let top = Infinity, left = Infinity;
            let bottom = -Infinity, right = -Infinity;
            $targets.each(function () {
                const rect = this.getBoundingClientRect();
                top = Math.min(top, rect.top);
                left = Math.min(left, rect.left);
                bottom = Math.max(bottom, rect.bottom);
                right = Math.max(right, rect.right);
            });
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            $spotlight.css({
                position: 'absolute',
                top: top + scrollTop,
                left: left + scrollLeft,
                width: right - left,
                height: bottom - top,
                opacity: 1,
                transition: 'all 0.3s ease'
            });
        }
        function setupPositionListeners($spotlight, $target) {
            _scrollHandler = () => positionSpotlight($spotlight, $target);
            _resizeHandler = () => positionSpotlight($spotlight, $target);
            $(window).on('scroll.appnTour', _scrollHandler);
            $(window).on('resize.appnTour', _resizeHandler);
        }
        function setupPositionListenersForMultiple($spotlight, $targets) {
            _scrollHandler = () => positionSpotlightForMultiple($spotlight, $targets);
            _resizeHandler = () => positionSpotlightForMultiple($spotlight, $targets);
            $(window).on('scroll.appnTour', _scrollHandler);
            $(window).on('resize.appnTour', _resizeHandler);
        }
        function removePositionListeners() {
            if (_scrollHandler) {
                $(window).off('scroll.appnTour', _scrollHandler);
                _scrollHandler = null;
            }
            if (_resizeHandler) {
                $(window).off('resize.appnTour', _resizeHandler);
                _resizeHandler = null;
            }
        }
    })(tour = appn.tour || (appn.tour = {}));
})(appn || (appn = {}));
